<template>
    <div class="rec-job-list">
        <div :class="['job-item', { active: check === item.id }]" v-for="item in list" :key="item.id" @click="handleCheck(item)">
            <div class="job-top">
                <div class="job-info flex-center">
                    <span class="info-name ellipsis-single">{{ item.name }}</span>

                    <span class="info-salary">{{ item.salary }}</span>
                </div>

                <div class="job-tags">
                    <i class="tag">{{ item.experience_type }}</i>
                    <i class="tag">{{ item.degree }}</i>
                </div>
            </div>

            <div class="job-bottom flex-center">
                <div class="job-company flex-center" v-if="isCompany">
                    <img :src="item.company_logo" alt="" class="company-logo" />
                    <span class="company-name ellipsis-single">{{ item.company_name }}</span>
                </div>

                <div class="job-address">{{ item.address }}</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {};
    },

    props: {
        list: {
            type: Array,
            required: true,
        },

        check: {
            type: Number,
        },

        isCompany: {
            type: Boolean,
            default: false,
        },
    },

    methods: {
        handleCheck(val) {
            this.$emit("change", val.id);
        },
    },
};
</script>

<style lang="scss" scoped>
.rec-job-list {
    .job-item {
        width: 100%;
        border: 1px solid transparent;
        border-radius: 12px;
        background-color: #fff;
        // min-height: 132px;
        cursor: pointer;
        overflow: hidden;

        & + .job-item {
            margin-top: 12px;
        }

        &.active {
            border-color: #685ef5;
        }

        .job-top {
            padding: 16px 20px;

            .job-info {
                gap: 20px;
                margin-bottom: 16px;

                .info-name {
                    font-weight: 400;
                    font-size: 16px;
                    color: #685ef5;
                    flex: 1;
                    min-width: 0;
                }

                .info-salary {
                    font-weight: bold;
                    font-size: 20px;
                    color: #ffa53d;
                }
            }

            .job-tags {
                display: flex;
                gap: 6px;

                i {
                    font-style: normal;
                    font-size: 12px;
                    padding: 4px 10px;
                    border-radius: 4px;
                    background-color: #ededee;
                }
            }
        }

        .job-bottom {
            height: 48px;
            background-color: #f8fbfc;
            padding-inline: 20px;
            justify-content: space-between;

            .job-company {
                gap: 8px;
                min-width: 0;

                img {
                    width: 24px;
                    height: 24px;
                    border-radius: 4px;
                    object-fit: cover;
                }

                .company-name {
                    font-weight: 400;
                    font-size: 14px;
                    color: #666666;
                }
            }

            .job-address {
                flex-shrink: 0;
                flex: 1;
                font-weight: 400;
                font-size: 14px;
                color: #666666;
                text-align: right;
                white-space: nowrap;
            }
        }
    }
}
</style>
